/*
  Notify Me — per-status button label.

  WHY THIS EXISTS
  The Notify Me app (cdn.notify-me.io) supports exactly one button label across
  the whole store. "Notify me" is right for something that sold out, but wrong
  for a product that has never been released — there, it is a waitlist.

  HOW IT WORKS
  The label comes from Liquid as `data-notify-label` on the `.product-form__buttons`
  container the app injects into. No product state is duplicated here: this file
  does not know what "preview" means, it just applies whatever label the theme
  put on the container. If the attribute is absent, nothing happens.

  The app renders `.nm-portal > button.restock-alerts-notify-button`, where the
  label is a bare TEXT NODE sitting next to an inline SVG icon. So this replaces
  that single text node rather than the button's innerHTML — the icon, the
  classes, the inline styles and, most importantly, the app's own click handler
  are all left untouched.

  The app mounts asynchronously and can re-render (variant change, modal close),
  so a MutationObserver re-applies the label. The `!== label` guard makes that
  safe: our own edit fires the observer once, finds nothing to do, and stops.

  The debounce uses setTimeout, NOT requestAnimationFrame. rAF is suspended in
  tabs that are not being painted — a background tab, or a page opened via
  "open in new tab" — so the observer would fire but its callback would never
  run and the label would stay wrong until the tab was focused. There is no
  painting reason to wait for a frame here; this is only coalescing bursts of
  mutations.
*/

(function () {
  const CONTAINER = '.product-form__buttons[data-notify-label]';
  const BUTTON = '.restock-alerts-notify-button';
  const WATCH_MS = 30000;

  function relabel() {
    let found = false;

    document.querySelectorAll(CONTAINER).forEach((container) => {
      const label = container.dataset.notifyLabel;
      if (!label) return;

      container.querySelectorAll(BUTTON).forEach((button) => {
        found = true;
        button.childNodes.forEach((node) => {
          if (node.nodeType !== Node.TEXT_NODE) return;
          if (!node.textContent.trim()) return;
          if (node.textContent.trim() === label) return;
          node.textContent = label;
        });
      });
    });

    return found;
  }

  relabel();

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      relabel();
    }, 0);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // The app renders late; stop watching once that window has passed rather than
  // observing the whole document for the life of the page.
  setTimeout(() => observer.disconnect(), WATCH_MS);
})();
